import abi from "./contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";
import './assets/css/style.css';
import './assets/css/bootstrap.css';
import Buy1 from "./component/buy1";


function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");

  const[wlevel1,setLevelw1]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
  const[refer4,setrefer4]=useState("None");
  const[refer3,setrefer3]=useState("None");
  const[refer1,setrefer1]=useState("None");
  const[refer2,setrefer2]=useState("None");
  const [ntasks,setnTasks] = useState([]);
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [tt2,settt2]=useState("None");
const [tt12,settt12]=useState("None");
const [tt13,settt13]=useState("None");
const [tt3,settt3]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
const[b5,setb5]=useState("None");
const[b6,setb6]=useState("None");
const[b7,setb7]=useState("None");
const[b8,setb8]=useState("None");
const[b9,setb9]=useState("None");
const[b10,setb10]=useState("None");
const[b11,setb11]=useState("None");
const[b12,setb12]=useState("None");
const[b13,setb13]=useState("None");
const[b14,setb14]=useState("None");
const[b15,setb15]=useState("None");
const[b16,setb16]=useState("None");
const[reward,setreward]=useState("None");
const[reward1,setreward1]=useState("None");
const[reward2,setreward2]=useState("None");
const[reward3,setreward3]=useState("None");
const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x5,setx5]=useState("None");
  useEffect(() => {
    
    const connectWallet = async () => {
      
      const contractAddress = "0x80d39245be13b32a2d9f17014c141a9c61b09500";
      const contractABI = abi.abi;
	 const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
if(myParam == null)
  {
    document.querySelector("#name").value="0x02eeD1A518053c24Cea6FBdF79345a6ad75D7a20";
  }

     

   
   
  try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
       
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
        
        
        
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );

          setAccount(account);
          setState({ provider, signer, contract });
		  
		  document.querySelector("#us").value  = account[0];
      let alltasks = await contract.getMemos(account[0])
      setTasks(alltasks);
      var i = 0;
      const refer = (alltasks[1]);
      setrefer(refer);
      const a1 = Number(alltasks[0]);
      sea1(a1);
      const refer2 = (alltasks[23]);
     setrefer2(refer2);
 
      const b =Number(alltasks[2]);
     

     document.querySelector("#hid").value  = (alltasks[1]);
     const direct =Number(alltasks[2]);
     setDirect(direct);
     const level = Number(alltasks[4]);
     setLevel(level);


     const plevel = Number(alltasks[21])/1000000000000000000;
     setLevelp(plevel);
     
    
     const pack = Number(alltasks[3]) ;

setpackage(pack);

document.querySelector("#pp").value  = Number(alltasks[3]);




     setB(b);

     

     const dd = Number(alltasks[26]);
          
     setDD(dd);

     const reward = Number(alltasks[11])/1000000000000000000;
          
     setreward(reward);
     const reward1 = Number(alltasks[28])/1000000000000000000;
          
     setreward1(reward1);
     const reward2 = Number(alltasks[29])/1000000000000000000;
          
     setreward2(reward2);
     const reward3 = Number(alltasks[30])/1000000000000000000;
          
     setreward3(reward3);



     const x1 = Number(alltasks[17])/1000000000000000000;
     setx1(x1);
     const x2 = Number(alltasks[18])/1000000000000000000;
     setx2(x2);
     const x3 = Number(alltasks[19])/1000000000000000000;
     setx3(x3);
     
       
       const b1 = Number(alltasks[5]) ;
       setb1(b1);
       const b2 = Number(alltasks[6]) ;
       setb2(b2);
       const b3 = Number(alltasks[7]) ;
       setb3(b3);
       const b4 = Number(alltasks[8]) ;
       setb4(b4);
       const b5 = Number(alltasks[9]) ;
       setb5(b5);
       const b6 = Number(alltasks[10]) ;
       setb6(b6);
       const b7 = Number(alltasks[11]) ;
       setb7(b7);
       const b8 = Number(alltasks[31]) ;
       setb8(b8);
       const b9 = Number(alltasks[32]) ;
       setb9(b9);
       const b10 = Number(alltasks[33]) ;
       setb10(b10);


     const wlevel = Number(alltasks[25])/1000000000000000000 ;
          
 setLevelw(wlevel);
 const wlevel1 = Number(alltasks[15])/1000000000000000000;
          
 setLevelw1(wlevel1);

 

    // document.querySelector("#wi1").value = roi2;
     
    // const a1 = Number(alltasks1[0])-1;
          

    // sea1(a1);
    // const a3 = Number(alltasks1[2])/1000000000000000000;
          
   //  sea3(a3);
     const a2 = Number(alltasks[24]);
    sea2(a2);   
     var rr = 0;
    // const tt4 =  Number(alltasks[15])/1000000000000000000;
    // settt4(tt4);
     
     const tt =  Number(alltasks[16])/1000000000000000000;
     settt(tt);
     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);
     document.querySelector("#bal").value = tt3;
     const referlink = 'https://bilionsmiles.com/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;


     const upd = b1+b2+b3+b4+b5+b6+b7+b8+b9+b10+b11+b12+b13+b14+b15;
          
     setupd(upd);

	 document.querySelector("#w1").value  = Number(alltasks[0]);
	 document.querySelector("#w2").value  = (alltasks[1]);
	 document.querySelector("#w3").value  = Number(alltasks[2]);
	 document.querySelector("#w4").value  = Number(alltasks[3]);
	 document.querySelector("#w5").value  = Number(alltasks[4]);
	 document.querySelector("#w6").value  = Number(alltasks[5]);
	 document.querySelector("#w7").value  = Number(alltasks[6]);
	 document.querySelector("#w8").value  = Number(alltasks[7]);
	 document.querySelector("#w9").value  = Number(alltasks[8]);
	 document.querySelector("#w10").value  = Number(alltasks[9]);
	 document.querySelector("#w11").value  = Number(alltasks[10]);
	 document.querySelector("#w12").value  = Number(alltasks[11]);
	 document.querySelector("#w13").value  = Number(alltasks[12]);
	 document.querySelector("#w14").value  = Number(alltasks[13]);
	 document.querySelector("#w15").value  = Number(alltasks[14]);
	 document.querySelector("#w16").value  = Number(alltasks[15]);
	 document.querySelector("#w17").value  = Number(alltasks[16]);
	 document.querySelector("#w18").value  = (alltasks[17]);
	 document.querySelector("#w19").value  = Number(alltasks[18]);
	 document.querySelector("#w20").value  = Number(alltasks[19]);
	 document.querySelector("#w21").value  = Number(alltasks[20]);
	 document.querySelector("#w22").value  = Number(alltasks[21]);
	 document.querySelector("#w23").value  = Number(alltasks[22]);
	 document.querySelector("#w24").value  = Number(alltasks[23]);
	 document.querySelector("#w25").value  = Number(alltasks[24]);
	 document.querySelector("#w26").value  = Number(alltasks[25]);
	 document.querySelector("#w27").value  = Number(alltasks[26]);

console.log(pack);

const pack1 = 200;
setpackage1(pack1);
     const dd2 = Number(alltasks[26]);
          
     setDD2(dd2);

     const dd1 =  Date.now() / 1000;
     setDD1(dd1);


     const tt1 = Math.trunc((dd1 - dd) / (3660 * 24 )) ;
   //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);
     
     settt1(tt1);

const tt2 = 1440 - Math.trunc((dd1 - dd2)/60) ;
       
       settt2(tt2);

      if(tt2<0)
      {
        const tt2 = 0;
       
       settt2(tt2);
        const x5 = "Next Trade Pending" ;
       setx5(x5);
      }
      else
      {
         const x5 = "Trade Already Claimed" ;
       setx5(x5);
      }


      const tt12 = Math.floor(tt2/60) ;
       
       settt12(tt12);
       const tt13 = tt2%60 ;
       
       settt13(tt13);


        if(tt12<0)
      {
        const tt12 = "00";
       
       settt12(tt12);
      }

       if(tt13<0)
      {
        const tt13 = "00";
       
       settt13(tt13);
      }


       document.querySelector("#tt2").value = tt2;
     



 
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }

  }, []);

 
  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>

	<input type="hidden" id ="w1"></input>
	<input type="hidden" id ="w2"></input>
	<input type="hidden" id ="w3"></input>
	<input type="hidden" id ="w4"></input>
	<input type="hidden" id ="w5"></input>
	<input type="hidden" id ="w6"></input>
	<input type="hidden" id ="w7"></input>
	<input type="hidden" id ="w8"></input>
	<input type="hidden" id ="w9"></input>
	<input type="hidden" id ="w10"></input>
	<input type="hidden" id ="w11"></input>
	<input type="hidden" id ="w12"></input>
	<input type="hidden" id ="w13"></input>
	<input type="hidden" id ="w14"></input>
	<input type="hidden" id ="w15"></input>
	<input type="hidden" id ="w16"></input>
	<input type="hidden" id ="w17"></input>
	<input type="hidden" id ="w18"></input>
	<input type="hidden" id ="w19"></input>
	<input type="hidden" id ="w20"></input>
	<input type="hidden" id ="w21"></input>
	<input type="hidden" id ="w22"></input>
	<input type="hidden" id ="w23"></input>
	<input type="hidden" id ="w24"></input>
	<input type="hidden" id ="w25"></input>
	<input type="hidden" id ="w26"></input>
	<input type="hidden" id ="w27"></input>
<section
  className="gap blog-section"
  style={{ backgroundImage: 'url(assets/img/background-1.png)' }}
>
  <div className="container">
    <div className="heading">
      <h2>Dashboard</h2>
    </div>

    <div className="row">

      <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 3v12"/>
  <path d="M7 10l5 5 5-5"/>
  <rect x="3" y="17" width="18" height="4" rx="1"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
                <Buy state={state}  />  </h2>
          <p style={{fontSize:"1.8rem"}}>
           
          </p>
        </div>
      </div>

      <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 3v12"/>
  <path d="M7 10l5 5 5-5"/>
  <rect x="3" y="17" width="18" height="4" rx="1"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
                <Buy1 state={state}  />  </h2>
          <p style={{fontSize:"1.8rem"}}>
           
          </p>
        </div>
      </div>
	     <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="9"/>
  <path d="M10 8h4a2 2 0 0 1 0 4h-4"/>
  <path d="M10 12h4a2 2 0 0 1 0 4h-4"/>
  <path d="M12 6v2M12 16v2"/>
</svg>

          </i>
		  
          <h>
			<br></br>
              <input type="text" id ="test" style={{ backgroundColor: "  #ef326f ",color:"white", marginTop:"2rem"}}></input>   </h>
          <p style={{fontSize:"1.8rem"}}>
            <Buy3 state={state}  />
          </p>
        </div>
      </div>
      <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
         <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 2l7 10-7 4-7-4z"/>
  <path d="M12 22l7-10-7 4-7-4z"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
          Next Claim</h2>
          <p style={{fontSize:"1.8rem"}}>
          <span class="counters" data-count={tt12}>{tt12} Hours and {tt13} Minutes </span>
          </p>
        </div>
      </div>
      <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
         <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 2l7 10-7 4-7-4z"/>
  <path d="M12 22l7-10-7 4-7-4z"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
          My Purchase</h2>
          <p style={{fontSize:"1.8rem"}}>
          <span class="counters" data-count={pack}>{pack} USDT</span>
          </p>
        </div>
      </div>
	   <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 3v12"/>
  <path d="M7 10l5 5 5-5"/>
  <rect x="3" y="17" width="18" height="4" rx="1"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
               Token Allocated   </h2>
          <p style={{fontSize:"1.8rem"}}>
            <span class="counters" data-count={pack1}>{pack1} BST</span>
          </p>
        </div>
      </div>
	     <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="9"/>
  <path d="M10 8h4a2 2 0 0 1 0 4h-4"/>
  <path d="M10 12h4a2 2 0 0 1 0 4h-4"/>
  <path d="M12 6v2M12 16v2"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
              Direct Team    </h2>
          <p style={{fontSize:"1.8rem"}}>
            <span class="counters" data-count= {direct}> {direct}</span>
          </p>
        </div>
      </div>
	    <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
         <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 2l7 10-7 4-7-4z"/>
  <path d="M12 22l7-10-7 4-7-4z"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
          Level Team</h2>
          <p style={{fontSize:"1.8rem"}}>
            <span class="counters" data-count={level}>{level}</span>
          </p>
        </div>
      </div>
	   <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 3v12"/>
  <path d="M7 10l5 5 5-5"/>
  <rect x="3" y="17" width="18" height="4" rx="1"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
               Total Team  </h2>
          <p style={{fontSize:"1.8rem"}}>
           <span class="counters" data-count={level + direct}>{level + direct}</span>
          </p>
        </div>
      </div>
	    
	    <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
         <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 2l7 10-7 4-7-4z"/>
  <path d="M12 22l7-10-7 4-7-4z"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
          Personal Growth Income</h2>
          <p style={{fontSize:"1.8rem"}}>
            {x1}
          </p>
        </div>
      </div>
	   <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 3v12"/>
  <path d="M7 10l5 5 5-5"/>
  <rect x="3" y="17" width="18" height="4" rx="1"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
              Direct Bonus    </h2>
          <p style={{fontSize:"1.8rem"}}>
             {x2}
          </p>
        </div>
      </div>
	     <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="9"/>
  <path d="M10 8h4a2 2 0 0 1 0 4h-4"/>
  <path d="M10 12h4a2 2 0 0 1 0 4h-4"/>
  <path d="M12 6v2M12 16v2"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
              Level Bonus    </h2>
          <p style={{fontSize:"1.8rem"}}>
            {x3}
          </p>
        </div>
      </div>
	    <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
         <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 2l7 10-7 4-7-4z"/>
  <path d="M12 22l7-10-7 4-7-4z"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
          Bronze Leadership Bonus</h2>
          <p style={{fontSize:"1.8rem"}}>
            {reward}
          </p>
        </div>
      </div>
	   <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 3v12"/>
  <path d="M7 10l5 5 5-5"/>
  <rect x="3" y="17" width="18" height="4" rx="1"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
                Silver Leadership Bonus  </h2>
          <p style={{fontSize:"1.8rem"}}>
            {reward1}
          </p>
        </div>
      </div>
	     <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="9"/>
  <path d="M10 8h4a2 2 0 0 1 0 4h-4"/>
  <path d="M10 12h4a2 2 0 0 1 0 4h-4"/>
  <path d="M12 6v2M12 16v2"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
               Gold Leadership Bonus   </h2>
          <p style={{fontSize:"1.8rem"}}>
             {reward2}
          </p>
        </div>
      </div>
	    <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
         <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 2l7 10-7 4-7-4z"/>
  <path d="M12 22l7-10-7 4-7-4z"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
           Diamond Leadership Bonus</h2>
          <p style={{fontSize:"1.8rem"}}>
            {reward3}
          </p>
        </div>
      </div>
	   <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 3v12"/>
  <path d="M7 10l5 5 5-5"/>
  <rect x="3" y="17" width="18" height="4" rx="1"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
              TOTAL Income    </h2>
          <p style={{fontSize:"1.8rem"}}>
             {tt} USDT
          </p>
        </div>
      </div>
	     <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="9"/>
  <path d="M10 8h4a2 2 0 0 1 0 4h-4"/>
  <path d="M10 12h4a2 2 0 0 1 0 4h-4"/>
  <path d="M12 6v2M12 16v2"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
               TOTAL WITHDRAWL  </h2>
          <p style={{fontSize:"1.8rem"}}>
            {wlevel1} USDT
          </p>
        </div>
      </div>
	    <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
         <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 2l7 10-7 4-7-4z"/>
  <path d="M12 22l7-10-7 4-7-4z"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
         PENDING INCOME</h2>
          <p style={{fontSize:"1.8rem"}}>
           {tt - wlevel1} USDT
                    
          </p>
        </div>
      </div>
	   
	    <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
         <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 2l7 10-7 4-7-4z"/>
  <path d="M12 22l7-10-7 4-7-4z"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
            Level 1 Team</h2>
          <p style={{fontSize:"1.8rem"}}>
           {b1} 
          </p>
        </div>
      </div>
	   <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 3v12"/>
  <path d="M7 10l5 5 5-5"/>
  <rect x="3" y="17" width="18" height="4" rx="1"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
             Level 2 Team    </h2>
          <p style={{fontSize:"1.8rem"}}>
           {b2}
          </p>
        </div>
      </div>
	     <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="9"/>
  <path d="M10 8h4a2 2 0 0 1 0 4h-4"/>
  <path d="M10 12h4a2 2 0 0 1 0 4h-4"/>
  <path d="M12 6v2M12 16v2"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
                Level 3 Team  </h2>
          <p style={{fontSize:"1.8rem"}}>
           {b3}
          </p>
        </div>
      </div>
	    <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
         <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 2l7 10-7 4-7-4z"/>
  <path d="M12 22l7-10-7 4-7-4z"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
          Level 4 Team</h2>
          <p style={{fontSize:"1.8rem"}}>
            {b4}
          </p>
        </div>
      </div>
	   <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 3v12"/>
  <path d="M7 10l5 5 5-5"/>
  <rect x="3" y="17" width="18" height="4" rx="1"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
                Level 5 Team  </h2>
          <p style={{fontSize:"1.8rem"}}>
            {b5}
          </p>
        </div>
      </div>
	     <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="9"/>
  <path d="M10 8h4a2 2 0 0 1 0 4h-4"/>
  <path d="M10 12h4a2 2 0 0 1 0 4h-4"/>
  <path d="M12 6v2M12 16v2"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
                Level 6 Team  </h2>
          <p style={{fontSize:"1.8rem"}}>
            {b6}
          </p>
        </div>
      </div>
	    <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
         <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 2l7 10-7 4-7-4z"/>
  <path d="M12 22l7-10-7 4-7-4z"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
           Level 7 Team</h2>
          <p style={{fontSize:"1.8rem"}}>
            {b7}
          </p>
        </div>
      </div>
	   <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 3v12"/>
  <path d="M7 10l5 5 5-5"/>
  <rect x="3" y="17" width="18" height="4" rx="1"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
               Level 8 Team   </h2>
          <p style={{fontSize:"1.8rem"}}>
            {b8}
          </p> 
        </div>
      </div>
	     <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="9"/>
  <path d="M10 8h4a2 2 0 0 1 0 4h-4"/>
  <path d="M10 12h4a2 2 0 0 1 0 4h-4"/>
  <path d="M12 6v2M12 16v2"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
               Level 9 Team    </h2>
          <p style={{fontSize:"1.8rem"}}>
           {b9}
          </p>
        </div>
      </div>
	    <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
         <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 2l7 10-7 4-7-4z"/>
  <path d="M12 22l7-10-7 4-7-4z"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
         Level 10 Team</h2>
          <p style={{fontSize:"1.8rem"}}>
             
                     {b10}
          </p>
        </div>
      </div>
	   <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 3v12"/>
  <path d="M7 10l5 5 5-5"/>
  <rect x="3" y="17" width="18" height="4" rx="1"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
              My Account    </h2>
          <p style={{fontSize:"1rem"}}>
             {account}
                     
          </p>
        </div>
      </div>
	     <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none"
 stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="9"/>
  <path d="M10 8h4a2 2 0 0 1 0 4h-4"/>
  <path d="M10 12h4a2 2 0 0 1 0 4h-4"/>
  <path d="M12 6v2M12 16v2"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
                 My Refer  </h2>
          <p style={{fontSize:"1rem"}}>
            {refer}
          </p>
        </div>
      </div>
	    <div className="col-lg-4">
        <div className="solutions" style={{ textAlign: "center" }}>
          <i style={{ display: "inline-flex", justifyContent: "center" }}>
         <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <path d="M12 2l7 10-7 4-7-4z"/>
  <path d="M12 22l7-10-7 4-7-4z"/>
</svg>

          </i>
		  
          <h2 style={{fontSize:"2rem",marginTop:"1.5rem",fontWeight:"bold"}}>
           REFER LINK</h2>
          <p style={{fontSize:"1rem"}}>
          
                     {referlink}<a href="#">
       <button><img src ="copy.png" width={"15px"} onClick={() => {
         navigator.clipboard.writeText(referlink);}} /></button></a>
          </p>
        </div>
      </div>
	   
    </div>
  </div>
</section>


     

   
  


<br></br>
<br></br>
</div>  
  );
}

export default App;